import React, { FC, createRef, useCallback } from 'react';
import { AutoSizer, Index, List, ListRowProps } from 'react-virtualized';
import { EadNode } from 'types';
import EadItem from './EadItem';
import { useEadTreeContext } from './EadTreeCtx';

const ROW_HEIGHT = 40;

export const listRef = createRef<List>();
/* 
const renderItem = (item: EadNode, keyPrefix: string) => {
  const onClick = function (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) {
    event.stopPropagation();
    item.expanded = !item.expanded;
    listRef.current?.recomputeRowHeights();
    listRef.current?.forceUpdate();
  };
  let children: React.ReactNode[] = [];
  let itemText = '';
  if (item.expanded) {
    itemText = '[-] ' + item.label ?? item.title ?? item.name;
    children = (item?.children ?? []).map((child, index) =>
      renderItem(child, keyPrefix + '-' + index.toString())
    );
  } else if (item.children?.length) {
    itemText = '[+] ' + item.label ?? item.title ?? item.name;
  } else {
    itemText = '    ' + item.label ?? item.title ?? item.name;
  }
  children.unshift(<div>{itemText}</div>);
  console.log({ item });
  return (
    <ul style={{ paddingLeft: 100 }}>
      <li key={keyPrefix} onClick={onClick}>
        {children}
      </li>
    </ul>
  );
}; */

function cellRenderer({
  data,
  listProps,
  heap,
  expandedNodesIdsHEAP,
  currentEadNode,
}: {
  data: EadNode[];
  listProps: ListRowProps;
  heap: Record<string, EadNode[]> | undefined;
  expandedNodesIdsHEAP: Record<string, boolean> | undefined;
  currentEadNode: EadNode | undefined;
}) {
  // const renderedCell = renderItem(
  //   data?.[listProps.index],
  //   listProps.index.toString()
  // );

  return (
    <div key={listProps.key} style={listProps.style}>
      <EadItem node={data[listProps.index]} level={2} />
    </div>
  );
}

function getExpandedItemCount(
  item: EadNode,
  childrenViewHeap: Record<string, EadNode[]>,
  expandedNodesIds: Record<string, boolean>
) {
  let count = 1;
  console.log('getExpandedItemCount');
  //if (expandedNodesIds.find((id) => item.id === id)) {
  if (expandedNodesIds[item.id]) {
    count += (childrenViewHeap?.[item.id] ?? [])
      .map((n) => getExpandedItemCount(n, childrenViewHeap, expandedNodesIds))
      .reduce(function (total: number, count: number) {
        return total + count;
      }, 0);
  }

  return count;
}

const useExpandedItemsCount2 = () => {
  const { childrenViewHeap, expandedNodesIdsHEAP } = useEadTreeContext();

  return useCallback(
    (node: EadNode) => {
      return getExpandedItemCount(
        node,
        childrenViewHeap ?? {},
        expandedNodesIdsHEAP ?? {}
      );
    },
    [childrenViewHeap, expandedNodesIdsHEAP]
  );
};

const VirtualTree: FC<{ data: EadNode[] }> = ({ data }) => {
  const getRowLength = useExpandedItemsCount2();
  const rowHeight = useCallback(
    (params: Index) => {
      return getRowLength(data[params.index]) * ROW_HEIGHT;
    },
    [data, getRowLength]
  );
  //const ref = useRef<List>(null);
  const {
    childrenViewHeap,
    currentEadNode,
    expandedNodesIdsHEAP,
  } = useEadTreeContext();

  return (
    <div
      style={{
        height: 'calc(100vh - 80px)',
        width: '485px',
        backgroundColor: 'white',
        position: 'relative',
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <List
            ref={listRef}
            //ref={ref}
            height={height}
            width={width}
            rowHeight={rowHeight}
            rowCount={data.length}
            rowRenderer={(listProps) =>
              cellRenderer({
                listProps,
                data,
                currentEadNode,
                heap: childrenViewHeap,
                expandedNodesIdsHEAP,
              })
            }
          />
        )}
      </AutoSizer>
    </div>
  );
};

export default VirtualTree;
